import { Select } from 'antd';
import React from 'react';

import { t } from '@System/i18n';

import { PRODUCT_STATUS } from '../services/constants';

const { Option } = Select;

export default function SelectStatuses(props) {
    return (
        <Select
            {...props}
            value={props.value || undefined}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
            {Object.keys(PRODUCT_STATUS).map(opt => {
                return (
                    <Option key={PRODUCT_STATUS[opt]} value={PRODUCT_STATUS[opt]}>
                        {t(`product:status.${PRODUCT_STATUS[opt]}`)}
                    </Option>
                );
            })}
        </Select>
    );
}
